import { render, staticRenderFns } from "./AddEditGift.vue?vue&type=template&id=f09a73a2"
import script from "./AddEditGift.vue?vue&type=script&lang=js"
export * from "./AddEditGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports